import { fetchAuthSession } from 'aws-amplify/auth';

import { getApiBaseUrl } from '../aws-exports';

interface ApiClientOptions {
  method?: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  body?: any;
  headers?: Record<string, string>;
}

export async function apiClient(endpoint: string, options: ApiClientOptions = {}) {
  const { method = 'GET', body, headers = {} } = options;

  const API_BASE_URL = getApiBaseUrl();

  try {
    // Amplifyのセッション取得 (未ログイン時は tokens が undefined)
    const session = await fetchAuthSession();
    const accessToken = session.tokens?.accessToken?.toString();
    const idToken = session.tokens?.idToken?.toString();

    const requestHeaders: Record<string, string> = {
      'Content-Type': 'application/json',
      ...headers,
    };

    // 推奨: API保護は access token を利用 (idToken は表示系属性用)
    const bearerSource = accessToken || idToken;
    if (bearerSource) {
      requestHeaders['Authorization'] = `Bearer ${bearerSource}`;
    } else {
      // 未ログイン / トークン未取得時は明示的にログを出して 401/403 切り分け支援
      console.warn('[apiClient] No Cognito tokens present; request will be unauthenticated');
    }

    const url = `${API_BASE_URL}${endpoint}`;
    const response = await fetch(url, {
      method,
      headers: requestHeaders,
      body: body ? JSON.stringify(body) : undefined,
    });

    if (!response.ok) {
      // 追加情報: レスポンス本文を短く取得 (JSON 期待) 失敗時は無視
      let extra = '';
      try {
        const text = await response.text();
        if (text) {
          extra = ` body="${text.substring(0, 200)}"`; // 200文字まで
        }
      } catch {}
      const error = new Error(
        `API request failed: ${response.status} ${response.statusText}${extra}`
      );
      (error as Error & { status: number }).status = response.status;
      throw error;
    }

    // 成功時 JSON 期待 (auth-test は Map返却)
    return await response.json();
  } catch (error) {
    console.error('[apiClient] API request error:', error);
    throw error;
  }
}
